import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../config/authConfig";
import axios from "axios";
//import { env } from "node:process";

const msalInstance = new PublicClientApplication(msalConfig);

///check url location here

let API_URL = "";

if (window.location.hostname.startsWith("localhost")) {
    API_URL = "https://localhost:44445/"; //TODO ==. check url 
} else {
    //deployed env
    API_URL = "https://" + window.location.hostname + "/";
}

//const API_URL = window.location.hostname; 
console.log('baseURL', API_URL);
const apiClient = axios.create({
    baseURL: API_URL ,   
});

msalInstance.initialize().then(() => {
    apiClient.interceptors.request.use(async (config) => {
        const account = msalInstance.getActiveAccount();
      //  console.log('apiClient account', account); 

        if (account) {
            const tokenResponse = await msalInstance.acquireTokenSilent({
                account: account,
                scopes: ["api://04502c6b-9193-4324-b4ac-3c8b4b9d551c/access_as_user"], // KNAdmin-API expose API setting ==> make sure this setting is correct in Azure App settings
            });
            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${tokenResponse.accessToken}`,
            };

           // console.log('accesstoken', tokenResponse.accessToken); 
        }
      
        return config;
    });
});

export default apiClient; 